<template>
	<div>
		<vue-particles 
			color="#808080"
			:particleOpacity="0.1"
			:particlesNumber="100"
			shapeType="circle"
			:particleSize="4"
			linesColor="#808080"
			:linesWidth="1"
			:lineLinked="true"
			:lineOpacity="0.9"
			:linesDistance="150"
			:moveSpeed="3"
			:hoverEffect="true"
			hoverMode="grab"
			:clickEffect="true"
			clickMode="push">
		</vue-particles>

		<div class="position-absolute error-header">
            <h1 class="large-header"><span class="blue">404 Not Found</span>.</h1>
            <h1 class="large-header">You seem lost</h1>
			<h1 class="large-header mt-5"><a class="text-dark" href="/"><u>Take me home</u></a></h1>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Header'
	}
</script>